import {z} from 'zod';

export const WorkshopVehicleClassFormSchema = z.object({
  name: z.string(),
});
